import React from "react";
import style from "./Header.module.css"; // CSSファイルをインポート

const Header = ({ toggleSidebar }) => {
  return (
    <header className={style.header}>
      <button className={style.menuButton} onClick={toggleSidebar}>
        &#9776; {/* ハンバーガーメニューアイコン */}
      </button>
      <h1>StudioMK</h1>
    </header>
  );
};

export default Header;
